import { Classes } from "./externals";
import * as React from "react";
import "./HeaderBase.scss";
export const HeaderBase = ({ title, children, hamburger, logo, }) => {
    return (React.createElement("div", { className: "header-flex" },
        React.createElement("nav", { className: `grey ${Classes.DARK}` },
            React.createElement("div", { className: `${Classes.NAVBAR_GROUP} ${Classes.ALIGN_LEFT}` },
                hamburger,
                React.createElement("img", { src: logo, alt: "logo", className: "logo" }),
                React.createElement("div", { className: "title" }, title)),
            React.createElement("div", { className: `${Classes.NAVBAR_GROUP} ${Classes.ALIGN_RIGHT}` }, children))));
};
HeaderBase.defaultProps = {
    logo: require("./gmv.png"),
};
//# sourceMappingURL=HeaderBase.js.map